<h1 mat-dialog-title>{{ 'page.workInstructions.saveAsTemplateDialog.title' | translate }}</h1>
<form #form="ngForm" [formGroup]="formGroup" (ngSubmit)="onFormDialogSubmit()">
  <div mat-dialog-content>
    <mat-radio-group class="vertical-radio-group mb-4" [formControl]="formGroup.controls.saveMode">
      <mat-radio-button [value]="'saveAsNew'">{{
        'page.workInstructions.saveAsTemplateDialog.saveAsNew' | translate
      }}</mat-radio-button>
      <mat-radio-button [value]="'saveIntoExisting'">{{
        'page.workInstructions.saveAsTemplateDialog.saveIntoExisting' | translate
      }}</mat-radio-button>
    </mat-radio-group>
    @switch (formGroup.controls.saveMode.value) {
      @case ('saveAsNew') {
        <div class="d-block">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'field.name' | translate }}</mat-label>
            <input matInput [formControl]="formGroup.controls.saveAsNewTemplateForm.controls.name" />
            <mat-error [control]="formGroup.controls.saveAsNewTemplateForm.controls.name"></mat-error>
          </mat-form-field>
        </div>
      }
      @case ('saveIntoExisting') {
        <div class="d-block">
          <mat-dropdown
            [formControl]="formGroup.controls.saveIntoExistingTemplateForm.controls.existingTemplate"
            [configurationInput]="{
              singleSelection: true,
              text: ('field.workInstructionTemplate' | translate),
              repositionDropdownList: true,
            }"
            [options]="store.templateDropdownOptions()"
            [isFormSubmitted]="form.submitted"
            (search)="searchSubject.next($event)"
          ></mat-dropdown>
        </div>
      }
    }
  </div>
  <mat-dialog-actions align="end">
    <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
    <button mat-flat-button type="submit">
      {{ 'page.workInstructions.saveAsTemplateDialog.title' | translate }}
    </button>
  </mat-dialog-actions>
</form>
